module.exports = __webpack_public_path__ + "static/media/full-download.9149554d.svg";